import HTTP from '@/plugins/http';

const withdrawBankApi = {
  page: '/withdrawBank/list/page',
  add: '/withdrawBank/add',
  del: '/withdrawBank/delete',
  update: '/withdrawBank/update',
  export: '/withdrawBank/export',
  withdrawal: '/sys/auto/bank/list',
  AutoUpdate: '/sys/auto/bank/update',
  AutoAdd: '/sys/auto/bank/insert',
  autoDeletes: '/sys/auto/bank/delete',
  bankcodeList: '/admin/getBankCodeList'
};

function getPage({ data, params }) {
  return HTTP({
    url: withdrawBankApi.page,
    method: 'post',
    data: { query: data, ...params }
  });
}
function doAdd(data) {
  return HTTP({
    url: withdrawBankApi.add,
    method: 'post',
    data
  });
}
function doDel(data) {
  return HTTP({
    url: withdrawBankApi.del,
    method: 'post',
    data
  });
}
function doUpdate(data) {
  return HTTP({
    url: withdrawBankApi.update,
    method: 'post',
    data
  });
}
function doExport(data) {
  return HTTP.loading({
    url: withdrawBankApi.export,
    method: 'post',
    data,
    timeout: 600000
  });
}

function AutoWithdrawal(data) {
  return HTTP.loading({
    url: withdrawBankApi.withdrawal,
    method: 'post',
    data
  });
}

function AutoUpdate(data) {
  return HTTP.loading({
    url: withdrawBankApi.AutoUpdate,
    method: 'post',
    data
  });
}

function AutodoAdd(data) {
  return HTTP.loading({
    url: withdrawBankApi.AutoAdd,
    method: 'post',
    data
  });
}

function autoPayment_deletes(data) {
  return HTTP.loading({
    url: withdrawBankApi.autoDeletes,
    method: 'post',
    data
  });
}

function getBankCodeList() {
  return HTTP({
    url: withdrawBankApi.bankcodeList,
    method: 'get'
  });
}

export default {
  getPage,
  doAdd,
  doDel,
  doUpdate,
  doExport,
  AutoWithdrawal,
  AutoUpdate,
  AutodoAdd,
  autoPayment_deletes,
  getBankCodeList
};



// WEBPACK FOOTER //
// ./src/api/withdrawBank.js